export const numberToOrdinal = (num: number): string => {
  const suffix = ['th', 'st', 'nd', 'rd']
  const divided = num % 100
  return num + (suffix[(divided - 20) % 10] || suffix[divided] || suffix[0])
}
